import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withKeys as _withKeys, withModifiers as _withModifiers, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { align: "center" }
const _hoisted_3 = { class: "text-subtitle-1 text-medium-emphasis" }
const _hoisted_4 = { class: "text-subtitle-1 text-medium-emphasis" }
const _hoisted_5 = { class: "text-subtitle-1 text-medium-emphasis" }
const _hoisted_6 = { class: "text-subtitle-1 text-medium-emphasis d-flex align-center justify-space-between" }
const _hoisted_7 = { class: "text-subtitle-1 text-medium-emphasis d-flex align-center justify-space-between" }
const _hoisted_8 = { align: "center" }

import { computed, ref } from 'vue'
import { useUserStore } from '../../../../stores/user-auth'
import { useI18n } from 'vue-i18n'
import HeaderComponent from '@/components/Header/HeaderComponent.vue'
import { useMeta } from 'vue-meta'
import FooterComponent from '@/components/Footer/FooterComponent.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'RegisterComponent',
  setup(__props) {

const { t } = useI18n()
const email = ref('')
const password = ref('')
const rePassword = ref('')
const firstName = ref('')
const lastName = ref('')
const isLoading = ref(false)
const showPassword = ref(false)
const showRePassword = ref(false)
const termsAndConditions = ref(false)
const responseStatus = ref({})
const successfullyRegistered = ref(false)

const emailRules = [
  (v: string) => !!v || t('email-required'),
  (v: string) => /.+@.+\..+/.test(v) || t('email-authentic'),
]

const passwordRules = [(v: string) => !!v || t('password-required')]

const notEmptyRule = [(v: string) => !!v || t('field-required')]

const passwordMatchingRule = [
  (v: string) => v == password.value || t('password-match'),
]

const isInfoCompleted = computed(() => {
  const isEmailInvalid = emailRules.some((rule) => {
    const result = rule(email.value)
    return typeof result === 'string'
  })

  const isPasswordInValid = passwordRules.some((rule) => {
    const result = rule(password.value)
    return typeof result === 'string'
  })

  const passwordDoNotMatch = passwordMatchingRule.some((rule) => {
    const result = rule(rePassword.value)
    return typeof result === 'string'
  })

  const isValid =
    firstName.value !== '' &&
    lastName.value !== '' &&
    termsAndConditions &&
    !isEmailInvalid &&
    !isPasswordInValid &&
    !passwordDoNotMatch &&
    termsAndConditions.value

  return isValid
})

useMeta(
  computed(() => ({
    title: 'Medcircle',
  }))
)

const register = async () => {
  isLoading.value = true
  const userStore = useUserStore()

  const credentials = {
    firstName: firstName.value,
    lastName: lastName.value,
    email: email.value ?? '',
    password: password.value,
    confirmPassword: rePassword.value,
    agreements: termsAndConditions.value,
  }
  const response = await userStore.register(credentials)
  responseStatus.value = response
  if (response.success) {
    successfullyRegistered.value = true
  }
  isLoading.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_request_status = _resolveComponent("request-status")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_card_item = _resolveComponent("v-card-item")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(HeaderComponent),
    _createVNode(_component_request_status, {
      response: responseStatus.value,
      isLoading: false
    }, null, 8, ["response"]),
    (!successfullyRegistered.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_v_card, {
            class: "mx-auto pa-12 pb-8 my-15",
            elevation: "8",
            "max-width": "448",
            rounded: "lg"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_v_img, {
                  width: "100px",
                  src: require('../../../../assets/stud1.png')
                }, null, 8, ["src"])
              ]),
              _createVNode(_component_v_card_title, { align: "center" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('student-register')), 1)
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('first-name')), 1),
              _createVNode(_component_v_text_field, {
                modelValue: firstName.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((firstName).value = $event)),
                density: "compact",
                placeholder: _ctx.$t('first-name'),
                "prepend-inner-icon": "mdi-pencil",
                rules: notEmptyRule,
                variant: "outlined",
                onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (isInfoCompleted.value ? register() : undefined), ["enter"]))
              }, null, 8, ["modelValue", "placeholder"]),
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('last-name')), 1),
              _createVNode(_component_v_text_field, {
                modelValue: lastName.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((lastName).value = $event)),
                density: "compact",
                placeholder: _ctx.$t('last-name'),
                "prepend-inner-icon": "mdi-pencil",
                rules: notEmptyRule,
                variant: "outlined",
                onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (isInfoCompleted.value ? register() : undefined), ["enter"]))
              }, null, 8, ["modelValue", "placeholder"]),
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('account')), 1),
              _createVNode(_component_v_text_field, {
                modelValue: email.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((email).value = $event)),
                density: "compact",
                placeholder: _ctx.$t('email'),
                "prepend-inner-icon": "mdi-email-outline",
                rules: emailRules,
                variant: "outlined",
                onKeyup: _cache[5] || (_cache[5] = _withKeys(($event: any) => (isInfoCompleted.value ? register() : undefined), ["enter"]))
              }, null, 8, ["modelValue", "placeholder"]),
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('password')), 1),
              _createVNode(_component_v_text_field, {
                modelValue: password.value,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((password).value = $event)),
                "append-inner-icon": showPassword.value ? 'mdi-eye-off' : 'mdi-eye',
                type: showPassword.value ? 'text' : 'password',
                density: "compact",
                placeholder: _ctx.$t('enter-password'),
                "prepend-inner-icon": "mdi-lock-outline",
                variant: "outlined",
                rules: passwordRules,
                "onClick:appendInner": _cache[7] || (_cache[7] = ($event: any) => (showPassword.value = !showPassword.value)),
                onKeyup: _cache[8] || (_cache[8] = _withKeys(($event: any) => (isInfoCompleted.value ? register() : undefined), ["enter"]))
              }, null, 8, ["modelValue", "append-inner-icon", "type", "placeholder"]),
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('re-password')), 1),
              _createVNode(_component_v_text_field, {
                modelValue: rePassword.value,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((rePassword).value = $event)),
                "append-inner-icon": showRePassword.value ? 'mdi-eye-off' : 'mdi-eye',
                type: showRePassword.value ? 'text' : 'password',
                density: "compact",
                placeholder: _ctx.$t('enter-password'),
                "prepend-inner-icon": "mdi-lock-outline",
                variant: "outlined",
                rules: passwordMatchingRule,
                "onClick:appendInner": _cache[10] || (_cache[10] = ($event: any) => (showRePassword.value = !showRePassword.value)),
                onKeyup: _cache[11] || (_cache[11] = _withKeys(($event: any) => (isInfoCompleted.value ? register() : undefined), ["enter"]))
              }, null, 8, ["modelValue", "append-inner-icon", "type", "placeholder"]),
              _createVNode(_component_v_checkbox, {
                modelValue: termsAndConditions.value,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((termsAndConditions).value = $event))
              }, {
                label: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('checkbox.agree')) + " ", 1),
                    _createVNode(_component_v_tooltip, { location: "bottom" }, {
                      activator: _withCtx(({ props }) => [
                        _createElementVNode("a", _mergeProps({
                          href: "/t-and-c",
                          target: "_blank"
                        }, props, {
                          onClick: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["stop"]))
                        }), _toDisplayString(_ctx.$t('checkbox.t&c')), 17)
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('checkbox.t&c')), 1)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_v_btn, {
                class: "mb-8",
                color: "blue",
                size: "large",
                variant: "flat",
                block: "",
                loading: isLoading.value,
                disabled: !isInfoCompleted.value,
                onClick: register
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('register')), 1)
                ]),
                _: 1
              }, 8, ["loading", "disabled"]),
              _createVNode(_component_v_card_text, { class: "text-center" }, {
                default: _withCtx(() => [
                  _createElementVNode("a", {
                    class: "text-blue text-decoration-none",
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.$router.push('/login'))),
                    rel: "noopener noreferrer",
                    style: {"cursor":"pointer"}
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('login')), 1),
                    _createVNode(_component_v_icon, { icon: "mdi-chevron-right" })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(FooterComponent)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_v_dialog, {
      modelValue: successfullyRegistered.value,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((successfullyRegistered).value = $event)),
      transition: "dialog-bottom-transition",
      width: "auto",
      style: {"font-family":"Verdana, Geneva, Tahoma, sans-serif"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, {
          "max-width": "544",
          elevation: "16",
          class: "mx-auto my-16",
          style: {"border-radius":"1%"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_v_card_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, { class: "mt-2" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('register-message-title')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_text, { class: "mt-3" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('register-message-text')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        class: "text-blue text-decoration-none",
                        rel: "noopener noreferrer",
                        style: {"cursor":"pointer"},
                        onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.$router.push('/login')))
                      }, _toDisplayString(_ctx.$t('back-login')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})